export default __webpack_public_path__ + "static/media/skylineBuilding.2aafe745.jpg";